import { ISortOption } from '~types/search'
import { SORT_EQUIVALENT } from './constants/sorts'

const filterSortsByValue = (sortOptions: string[]): ISortOption[] => {
  return SORT_EQUIVALENT.reduce<ISortOption[]>((acc, option) => {
    if (sortOptions.includes(option.searchBy)) {
      acc.push(option)
    }
    return acc
  }, [])
}

export default filterSortsByValue
